import { render } from "./Option.vue?vue&type=template&id=1ed45436&scoped=true"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"

import "./Option.vue?vue&type=style&index=0&id=1ed45436&scoped=true&lang=scss"
import "./Option.vue?vue&type=style&index=1&id=1ed45436&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed45436"]])

export default __exports__